import { render, staticRenderFns } from "./PreviewCourse.vue?vue&type=template&id=5f6f429b&scoped=true"
import script from "./PreviewCourse.vue?vue&type=script&lang=js"
export * from "./PreviewCourse.vue?vue&type=script&lang=js"
import style0 from "./PreviewCourse.vue?vue&type=style&index=0&id=5f6f429b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f429b",
  null
  
)

export default component.exports